import { axiosInstance } from "@/lib/axiosInstance";

export interface DocumentType {
  id: string;
  student_id: string;
  document_type: string;
  file_url: string;
  verification_status: "pending" | "verified" | "rejected" | string;
  college_doc_ref_id: string | null;
  uploaded_at: string;
}

export const fetchDocuments = async (): Promise<DocumentType[]> => {
  const res = await axiosInstance.get("/v1/documents");
  return res.data?.data && Array.isArray(res.data.data) ? res.data.data : res.data;
};

export const uploadDocument = async (file: File, document_type: string): Promise<DocumentType> => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("document_type", document_type);

  const res = await axiosInstance.post("/v1/documents", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
};

export const deleteDocument = async (id: string): Promise<{ message: string }> => {
  const res = await axiosInstance.delete(`/v1/documents/${id}`);
  return res.data;
};

// verifyDocument was removed: verification is a college-side action, and the
// call pointed at an internal/v1 route that this app should never reach for.
// It was unwired, and its URL was built without the internal base override, so
// it resolved under /student/api/ and 404'd anyway.
